import { Stack, Container } from "@mui/material";
//zui
import Iconify from 'src/components/Iconify';
import { Button } from 'src/@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'src/@/components/ui/card';
import { Label } from 'src/@/components/ui/label';
import { Input } from 'src/@/components/ui/input';
import { RowInput } from 'src/components/forms/RowInput';
import { RadioGroup, RadioGroupItem } from 'src/@/components/ui/radio-group';
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select"
import { Slider } from 'src/@/components/ui/slider';
import { Textarea } from 'src/@/components/ui/textarea';
import { Switch } from 'src/@/components/ui/switch';
import { useTranslation } from 'react-i18next';
import ContainerOptions from "../components/ContainerOptions";

export default function AiAgentProfileTab({
    aiAgent,
    config,
    changePersona,
    changeCompanyName,
    changeCreativity,
    changeTemperature,
    changeBusinessActivity,
    changeTypeCommunication,
    changeAgentType,
    changeAgentFunction,
    changeName,
    changeModuleAgentType,
    hasModulesFeature,
}) {
    const { t } = useTranslation('settings');

    // O `value` viaja como `agentType` para o lais-ai (lais-webhook manda
    // config.module_agent_type cru) — precisa bater com a chave do agentRegistry lá.
    const MODULE_TYPES = [
        { value: 'realestate', label: t('aiAgents.profile.moduleRealestateLabel', 'Imobiliária'), icon: 'mdi:home-city-outline' },
        { value: 'ecommerce', label: t('aiAgents.profile.moduleEcommerceLabel', 'Varejo / E-commerce'), icon: 'mdi:cart-outline' },
        { value: 'comercial', label: t('aiAgents.profile.moduleComercialLabel', 'Comercial (propostas)'), icon: 'mdi:file-document-edit-outline' },
    ];

    return (
        <>
            <Stack sx={{ my: 5 }} direction={"column"} spacing={3}>
                {hasModulesFeature && (
                    <Card className="rounded-xl border border-gray-100">
                        <CardHeader>
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50">
                                    <Iconify icon="eva:layers-outline" width={20} className="text-violet-600" />
                                </div>
                                <div>
                                    <CardTitle>{t('aiAgents.profile.moduleTypeTitle', 'Tipo de módulo')}</CardTitle>
                                    <CardDescription>{t('aiAgents.profile.moduleTypeDescription', 'Selecione o módulo vertical que este agente representa para habilitar configurações específicas.')}</CardDescription>
                                </div>
                            </div>
                        </CardHeader>
                        <CardContent>
                            <div className="flex flex-col gap-2 max-w-md">
                                <Label className="text-xs font-semibold uppercase tracking-wider text-gray-500">{t('aiAgents.profile.moduleLabel', 'Módulo')}</Label>
                                <Select value={aiAgent?.config?.module_agent_type || ''} onValueChange={changeModuleAgentType}>
                                    <SelectTrigger className="rounded-xl border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20">
                                        <SelectValue placeholder={t('aiAgents.profile.modulePlaceholder', 'Selecione um tipo de módulo')} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {MODULE_TYPES.map((item) => (
                                            <SelectItem key={item.value} value={item.value}>
                                                <div className="flex items-center gap-2">
                                                    <Iconify icon={item.icon} width={16} className="text-violet-600" />
                                                    <span>{item.label}</span>
                                                </div>
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                        </CardContent>
                    </Card>
                )}
                <ContainerOptions>
                    <Stack direction={"row"} spacing={1}>
                        <RowInput
                            sx={{ width: '100%' }}
                            label={t('aiAgents.profile.nameLabel', 'Nome do agente')}
                            input={
                                <Input
                                    name="name"
                                    value={aiAgent?.name}
                                    onChange={(e) => {
                                        changeName(e.target.value)
                                        //  setAiAgent({ ...aiAgent, config: { ...aiAgent.config, promptGuide: { ...aiAgent.config.promptGuide, persona: e.target.value } } })
                                    }}
                                />
                            }
                        />
                        {aiAgent?.config?.generalConfig?.type === "stepByStep" && (
                            <RowInput
                                sx={{ width: '100%' }}
                                label={t('aiAgents.profile.personaLabel', 'Persona')}
                                input={
                                    <Input
                                        name="name"
                                        value={aiAgent?.config?.promptGuide?.persona}
                                        onChange={(e) => {
                                            changePersona(e.target.value)
                                            //  setAiAgent({ ...aiAgent, config: { ...aiAgent.config, promptGuide: { ...aiAgent.config.promptGuide, persona: e.target.value } } })
                                        }}
                                    />
                                }
                            />
                        )}

                        {aiAgent?.config?.generalConfig?.type === "stepByStep" && (

                            <RowInput
                                sx={{ width: '100%' }}

                                label={t('aiAgents.profile.companyNameLabel', 'Nome da empresa')}
                                input={
                                    <Input
                                        value={aiAgent?.config?.promptGuide?.companyName}
                                        onChange={(e) => {
                                            changeCompanyName(e.target.value)
                                            // setAiAgent({ ...aiAgent, config: { ...aiAgent.config, promptGuide: { ...aiAgent.config.promptGuide, companyName: e.target.value } } })
                                        }}
                                    />
                                }
                            />
                        )}


                    </Stack>
                </ContainerOptions>

                {aiAgent?.config?.module_agent_type !== 'realestate' && (
                    <ContainerOptions>
                        <Stack direction={"row"} spacing={1}>

                            <div className='w-full'>
                                <ContainerOptions>
                                    <RowInput
                                        label={t('aiAgents.profile.creativityLabel', 'Criatividade do agente')}
                                        input={
                                            <div className="pt-2">
                                                <Slider
                                                    onValueChange={(value) => {
                                                        changeTemperature(value);
                                                        // setAiAgent({ ...aiAgent, config: { ...aiAgent.config, promptGuide: { ...aiAgent.config.promptGuide, creativity: value } } })
                                                    }}
                                                    defaultValue={[aiAgent?.config?.generalConfig?.temperature]}
                                                    max={10}
                                                    step={1}
                                                />
                                                <div className="flex justify-between mt-2">
                                                    <p className="text-[10px]">{t('aiAgents.profile.creativityLowLabel', 'pouco criativo')}</p>
                                                    <p className="text-[10px]">{t('aiAgents.profile.creativityHighLabel', 'muito criativo')}</p>
                                                </div>
                                            </div>
                                        }
                                    />
                                </ContainerOptions>
                            </div>

                        </Stack>
                    </ContainerOptions>
                )}



                <Stack direction="row" spacing={2}>


                    {aiAgent?.config?.generalConfig?.type === "stepByStep" && (
                        <>
                            <div className='w-full'>
                                <ContainerOptions>
                                    <RowInput
                                        label={t('aiAgents.profile.functionLabel', 'Função')}
                                        input={
                                            <RadioGroup
                                                value={aiAgent?.config?.generalConfig?.agent_function_id}
                                                onValueChange={(value) => changeAgentFunction(value)}
                                                className="grid grid-cols-2 gap-4"
                                            >
                                                {config?.agentFunctions.map((option) => (
                                                    <div className='cursor-pointer w-full' key={option._id}>
                                                        <RadioGroupItem
                                                            value={option._id}
                                                            id={option._id}
                                                            className="peer sr-only "
                                                        />
                                                        <Label
                                                            htmlFor={option._id}
                                                            className={`flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-2 hover:bg-accent hover:text-accent-foreground ${aiAgent?.config?.generalConfig?.agent_function_id === option._id ? 'bg-violet-500 text-white' : ''}`}
                                                        >
                                                            {option.name}
                                                        </Label>
                                                    </div>
                                                ))}
                                            </RadioGroup>
                                        }
                                    />
                                </ContainerOptions>
                            </div>
                            <div className="w-full">
                                <ContainerOptions>
                                    <Stack spacing={2} direction={"row"}>
                                        <RowInput

                                            label={t('aiAgents.profile.activityLabel', 'Atividade')}
                                            input={<Select
                                                value={aiAgent?.config?.promptGuide?.business_activities_id}
                                                onValueChange={(value) => changeBusinessActivity(value)}
                                            >
                                                <SelectTrigger className="w-full">
                                                    <SelectValue placeholder={t('aiAgents.profile.activityPlaceholder', 'Selecione uma atividade')} />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    {config?.businessActivities.map((i) => (
                                                        <SelectGroup key={i._id}>
                                                            <SelectItem value={i._id}>{i.name}</SelectItem>
                                                        </SelectGroup>
                                                    ))}
                                                </SelectContent>
                                            </Select>}
                                        />

                                        <RowInput
                                            label={t('aiAgents.profile.communicationLabel', 'Comunicação')}
                                            input={<Select value={aiAgent?.config?.promptGuide?.type_speaking_id}
                                                onValueChange={(value) => {
                                                    changeTypeCommunication(value)
                                                    // setAiAgent({ ...aiAgent, config: { ...aiAgent.config, promptGuide: { ...aiAgent.config.promptGuide, type_speaking_id: value } } })
                                                }}
                                            >
                                                <SelectTrigger className="w-full">
                                                    <SelectValue placeholder="" />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    {config?.typeComunications.map((i) => (
                                                        <SelectGroup key={i._id}>
                                                            <SelectItem value={i._id}>{i.name}</SelectItem>
                                                        </SelectGroup>
                                                    ))}
                                                </SelectContent>
                                            </Select>}
                                        />
                                    </Stack>
                                </ContainerOptions>
                            </div>

                        </>
                    )}

                </Stack>
            </Stack>
        </>

    )

}